import { Modal } from "ui/Modal"
import { Button, Flex } from "antd"
import { Text } from "ui/Typography"
import { spacings } from "themes/variables"
import { useTranslation } from "react-i18next"
import PropTypes from "prop-types"
import { useSelector } from "react-redux"

const DeleteTimeOff = ({ open, onCancel, onYes }) => {
  const { t } = useTranslation()
  const { loading } = useSelector((state) => state.calendar.timeOffDelete)

  return (
    <Modal centered title={`${t("calendar.schedule_time_off.delete_time_off")}?`} open={open} onCancel={onCancel} width={430}>
      <Flex vertical gap={spacings.XL}>
        <Text>{t("calendar.schedule_time_off.delete_time_off_confirmation")}</Text>
        <Flex gap={spacings.S}>
          <Button variant="outlined" color="primary" onClick={onCancel} disabled={loading}>
            {t("global.cancel")}
          </Button>
          <Button type="primary" danger onClick={onYes} disabled={loading} loading={loading}>
            {t("global.yes")}
          </Button>
        </Flex>
      </Flex>
    </Modal>
  )
}

DeleteTimeOff.propTypes = {
  open: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onYes: PropTypes.func.isRequired
}

export default DeleteTimeOff
